<template>
<div class="StepFour">
    <div class="top_div">
        <div class="left_div">
            <p class="p1">企业估值结果</p>
            <p class="p2"><span>{{resultData.evresult}}</span>万元</p>
            <p class="p3">此结果根据您填入的数据计算得出，人工智能估值结果仅供参考。</p>
            <img class="qr_img" src="http://img.capwhale.com/gj_dyh.jpg" alt="logo">
            <p class="p4">关注公众号获取更多信息</p>
        </div>
        <div class="right_div">
            <p class="p_tips">已为您免费生成企业估值报告,填写信息即可下载免费报告。</p>
            <div class="info_warp">
                
                <el-form label-width="80px" :model="api" :rules="rules" ref="ruleForm">
                    <el-form-item label="公司名称" prop="companyname">
                        <el-input style="width: 380px;" v-model="api.companyname" placeholder="请输入公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="linkman">
                        <el-input style="width: 380px;" v-model="api.linkman" placeholder="请输入联系人"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="linktel">
                        <el-input style="width: 380px;" v-model="api.linktel" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="职位" prop="linkduty">
                        <el-input style="width: 380px;" v-model="api.linkduty" placeholder="请输入职位"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="usercode">
                        <el-input style="width: 260px;" v-model="api.usercode" placeholder="请输入验证码" maxlength="4"></el-input>
                        <img style="width: 100px; height:40px;margin-right:20px;cursor:pointer; float: right" :src="base64" @click="getCode()" alt="验证码">
                    </el-form-item>
                </el-form>
                <!-- <div class="info_item_div" v-for="(item, index) in infoData" :key="index">
                    <span>{{item.title}}</span>
                    <el-input style="width: 380px;" v-model="item.inputValue" :placeholder="item.placeholder"></el-input>
                </div>
                <div class="info_item_div">
                    <span>验证码：</span>
                    <el-input style="width: 260px;" v-model="usercode" placeholder="请输入验证码"></el-input>
                    <img style="width: 100px; height:40px;margin-right:20px;cursor:pointer;" :src="base64" @click="getCode()" alt="验证码">
                    <input style="width:0; height:0"/>
                </div> -->
            </div>
            <el-button @click="getReport('ruleForm')" type="primary" round>免费获取报告</el-button>
        </div>
    </div>
    <div v-if="recommendCourseData.length > 0" class="bottom_div">
        <div class="title_box">
            <p>为您推荐以下股权课程</p>
            <span @click="moreClick">更多 ></span>
        </div>
        <div class="recommend_box">
            <div @click="courseClick(item)" v-for="(item, index) in recommendCourseData" :key="index" class="recommend__item_div">
                <!-- <img :src="require('@/common/images/header/test.jpg')" alt=""> -->
                <img v-lazy="item.coverurl" alt="">
                <p>{{item.subject}}</p>
            </div>
        </div>
    </div>
    <div class="download_report_pop">
        <el-dialog :visible.sync="dialogVisible">
            <div class="pop_content_box">
                <img :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
                <p>您已成功获取企业估值报告<br />点击下方按钮进行下载</p>
                <el-button type="primary" @click="downloadPdf(pdfUrl)">点击下载报告</el-button>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {getRecommendCourse, dealSwEvOrderinfo, createCode} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'StepFour',
    data() {
        var justcompanyname = (rule, value, callball) => {
            if (!value) {
                return callball(new Error('公司名称不能为空'))
            }
            callball()
        }
        var justlinkman = (rule, value, callball) => {
            if (!value) {
                return callball(new Error('联系人不能为空'))
            }
            callball()
        }
        var justlinktel = (rule, value, callball) => {
            if (!value) {
                return callball(new Error('联系电话不能为空'))
            } else {
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                    return callball(new Error('请输入与正确的联系电话'))
                }
            }
            callball()
        }
        var justlinkduty = (rule, value, callball) => {
            if (!value) {
                return callball(new Error('职位不能为空'))
            } 
            callball()
        }
        var justusercode = (rule, value, callball) => {
            if (!value) {
                return callball(new Error('验证码不能为空'))
            }
            callball()
        }
        return {
            pdfUrl: '',
            dialogVisible: false,
            // inputValue: '',
            recommendCourseData: [],
            resultData: {
                evresult: '--',
                orderno: ''
            },
            base64: '', // 验证码图片
            api: {
                orderno: '',
                companyname: '',
                linkman: '',
                linktel: '',
                linkduty: '',
                usercode: '',
                codeEncryption: ''   // 加密后的验证码       
            },
            rules: {
                companyname: [
                    {validator: justcompanyname, trigger: 'blur'}
                ],
                linkman: [
                    {validator: justlinkman, trigger: 'blur'}
                ],
                linktel: [
                    {validator: justlinktel, trigger: 'blur'}
                ],
                linkduty: [
                    {validator: justlinkduty, trigger: 'blur'}
                ],
                usercode: [
                    {validator: justusercode, trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        // this.findRecommendCourse()
        this.getCode()
        setTimeout(() => {
            $('html').scrollTop(0)
        }, 500)
    },
    methods: {
        // 验证码
        getCode() {
          this.setLoading(true)
          createCode({
              data: {},
              success: data => {
                   this.setLoading(false)
                   this.base64 = data.result.base64
                   this.api.codeEncryption = data.result.codeEncryption
              },
              error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
              }
          })
        },
        // 下载报告
        downloadPdf(url) {
            this.setLoading(true)
            fetch(url).then(res => res.blob()).then(blob => {
                // console.log(blob)
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style.display = 'none'
                // 使用获取到的blob对象创建的url
                const url = window.URL.createObjectURL(blob)
                a.href = url
                // 指定下载的文件名
                a.download = '企业估值报告'
                this.setLoading(false)
                this.dialogVisible = false
                a.click()
                document.body.removeChild(a)
                // 移除blob对象的url
                window.URL.revokeObjectURL(url)
            })
        },
        // 免费获取报告
        getReport(ruleForm) {
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    this.setLoading(true)
                    dealSwEvOrderinfo({
                        data: this.api,
                        success: data => {
                            // console.log(data)
                            this.setLoading(false)
                            this.pdfUrl = data.data.evreporturl
                            this.dialogVisible = true
                        },
                        error: data => {
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        // 获取估值结果数据
        getResultData(val) {
            this.findRecommendCourse()
            this.api.orderno = val.orderno
            // console.log('估值结果：', val)
            this.resultData = val
            let result = val.evresult

            this.resultData.evresult = 0

            var stepNum = 1
            var timeStep = 30

            if (result>0 && result<100) {
                stepNum = 1
                timeStep = 100
            }
            if (result>=100 && result<500) {
                stepNum = 3
                timeStep = 70
            }
            if (result>=500 && result<1000) {
                stepNum = 7
                timeStep = 40
            } 
            if (result > 1000) {
                stepNum = 11
                timeStep = 30
            }
            for (let index = 0; index < 1000; index++) {
                if (index < 990) {
                    setTimeout(()=>{
                        this.resultData.evresult = this.resultData.evresult + stepNum
                        if (this.resultData.evresult >= result) {
                            this.resultData.evresult = result
                            return
                        }
                        if (index === 989) {
                            this.resultData.evresult = result
                            return
                        }
                    }, timeStep)
                }
            }
        },
        // 获取股鲸推荐课程
        findRecommendCourse() {
            this.setLoading(true)
            let params = {}
            getRecommendCourse({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.recommendCourseData = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        // 更多课程
        moreClick() {
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/search?catecode=01&typeData=0102&token=${this.user.loginToken}`)
            } else {
                window.open(`${this.domainlist.url_course}/search?catecode=01&typeData=0102`)
            }
        },
        // 点击推荐课程
        courseClick(val) {
            // window.open(`http://local.ke.capwhale.com:6001/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}`)
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}&chid=${this.channelid}`)
            } else {
                window.open(`${this.domainlist.url_course}/coursedetails?cid=${val.courseid}&chid=${this.channelid}`)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainlist',
            'channelid'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.StepFour {
    width: 1200px;
    margin: 0 auto;
    background-color: rgb(255, 255, 255);
    box-sizing: border-box;
    padding: 0 11px;
    font-family:PingFangSC-Regular,PingFang SC;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .top_div {
        // margin-bottom: 42px;
        box-sizing: border-box;
        width: 1100px;
        // height: 400px;
        padding: 30px 0;
        border:1px solid #E5E5E5;
        display: flex;
        .left_div {
            width: 560px;
            box-sizing: border-box;
            border-right:1px solid #E5E5E5;
            padding-top: 12px;
            padding-bottom: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .p1 {
                line-height:30px;
                font-size:22px;
                margin-bottom: 20px;
            }
            .p2 {
                color: #666;
                font-size:28px;
                height: 68px;
                display: flex;
                align-items: center;
                &>span {
                    margin-right: 20px;
                    font-size:48px;
                    color: #F56C6C;
                }
            }
            .qr_img {
                width: 120px;
                height: 120px;
                margin-top: 30px;
                margin-bottom: 6px;
            }
            .p3, .p4 {
                color: #999;
                line-height:20px;
            }
            .p4 {
                color: #333;
            }
        }
        .right_div {
            flex: 1;
            padding-left: 40px;
            .p_tips {
                line-height:20px;
                color: #F56C6C;
            }
            .info_warp {
                padding: 30px 0;
                padding-top: 10px;
                .info_item_div {
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    &>span {
                        color: #333;
                        width: 70px;
                        margin-right: 10px;
                        line-height:20px;
                    }
                }
            }
            .el-button {
                margin-left: 132px;
                width: 200px;
                height: 40px;
                font-size:16px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
            }
        }
    }
    .bottom_div {
        flex: 1;
        .title_box {
            display: flex;
            justify-content: space-between;
            margin-top: 42px;
            margin-bottom: 30px;
            line-height:26px;
            &>p {
                font-size:18px;
                color: #666;
            }
            &>span {
                font-size:14px;
                cursor: pointer;
                color: #999;
            }
        }
        .recommend_box {
            width: 1178px;
            display: flex;
            .recommend__item_div {
                width: 226px;
                margin-right: 12px;
                margin: 0 6px;
                padding-bottom: 12px;
                &>img {
                    border-radius: 4px 4px 0 0;
                    width: 226px;
                    height: 128px;
                    margin-bottom: 12px;
                    cursor: pointer;
                }
                &>p {
                    padding: 0 5px;
                    text-align: justify;
                    cursor: pointer;
                    line-height:24px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
            .recommend__item_div:hover{
                transition: all .3s;
                -moz-transition: all .3s;
                -o-transition: all .3s;
                -ms-transition: all .3s;
                -webkit-transition: all .3s;
                box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
            }
            .recommend__item_div:nth-of-type(1){
                margin-left: 0;
            }
            .recommend__item_div:nth-last-of-type(1){
                margin-right: 0;
            }
        }
    }
}
</style>
<style lang="scss">
    .el-form {
        margin-top: 20px;
        .el-form-item__label {
            text-align: left;
            padding-right: 0;
        }
    }
    .download_report_pop {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
        }
        .el-dialog {
            margin: 0!important;
            width: 380px;
            border-radius: 6px;
            overflow: hidden;
        }
        .el-dialog__header {
            padding: 0!important;
            height: 40px;
            display: flex;
            align-items: center;
            .el-dialog__title {
                font-size: 14px;
                line-height:20px;
                padding-left: 20px;
            }
            .el-dialog__headerbtn {
                font-size: 20px;
                top: 10px;
            }
        }
        .el-dialog .el-dialog__body {
            padding-top: 20px;
            box-sizing: border-box;
        }
        .pop_content_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            &>img {
                width: 114px;
                height: 75px;
                margin-bottom: 28px;
            }
            &>p {
                color: #333;
                line-height:24px;
                text-align: center;
                margin-bottom: 30px;
            }
            .el-button {
                width: 280px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
            }
        }
    }
</style>